import React from 'react';
import { css } from '@emotion/core';
import { Flex } from '@rebass/emotion';
import { rem } from '../../utils';

const Container = props => <Flex  {...props} width={1} mx={'auto'} px={ rem(25) } css={ css`max-width: ${ rem(1140) };` } />;

export default Container;
